import { useTranslation } from 'react-i18next'
import { EmptyState } from '@/ds'
import type { ServiceErrorCode } from '@/services/errors'

/** Error o sin conexión de una parte de la pantalla (DESIGN.md §4 estados): el resto sigue visible. */
export function SectionError({ code, onRetry }: { code: ServiceErrorCode; onRetry: () => void }) {
  const { t } = useTranslation()
  if (code === 'offline') {
    return <EmptyState icon="wifi-off" title={t('v2.ds.offline')} actionLabel={t('v2.comun.reintentar')} onAction={onRetry} />
  }
  return (
    <EmptyState tone="error" title={t('v2.legacy.error.defaultTitle')} actionLabel={t('v2.comun.reintentar')} onAction={onRetry}>
      {t('v2.legacy.error.tryAgainOrContactUs')}
    </EmptyState>
  )
}
